import Image from 'next/image'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import style from './employment.module.css'


export default function EmploymenttHeroComponent() {
    return (
        <article className='sectionOrArticleTB'>
            <div className='text-center'>
                <h1 className='caregoriesTitle'>We are Hiring!</h1>
            </div>
            <article className='sectionOrArticleB'>
                <div className='imgStripContainer'>
                    <div className='imgStripText'>
                        <Image src='/images/Strip5.gif'
                            alt="Strip"
                            fill
                            sizes="(max-width: 768px) 100vw,
                      (max-width: 1200px) 50vw,
                      33vw"
                        />
                    </div>
                </div>
            </article>
            <article className='sectionOrArticleT mt-5 mt-lg-0 mt-xl-0 mt-xxl-0'>
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={11} md={10} lg={9} xl={8}>

                            <p>
                                Coin Trader: Buys, grades and sells medium value world coins.

                                Travel ranging from 1 to 3 days, 20 to 30 times per year, required

                                to various unanticipated coin shows and vendor locations throughout

                                the continental United States. Send resume to Fl Gold Coin

                                Exchange, attn. A. Turchak, 22509 Hale Rd, Land O Lakes, FL 34639.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </article>
        </article>
    )
}